import { action } from 'typesafe-actions';
import { SemaphoreTypes, Semaphore } from './types';

export const loadRequest = (cd: number, inscricao: number[]) =>
  action(SemaphoreTypes.LOAD_REQUEST, { cd, inscricao });

export const loadSuccess = (data: Semaphore[]) => action(SemaphoreTypes.LOAD_SUCCESS, { data });

export const loadFailure = () => action(SemaphoreTypes.LOAD_FAILURE);
